export const TickMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    {...props}
  >
    <path
      d="M20.3917 2.21254L7.11247 16.8952L1.77308 10.294"
      stroke="url(#paint0_linear_25429_33791)"
      stroke-width="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_25429_33791"
        x1="10.6958"
        y1="4.81055"
        x2="13.4769"
        y2="15.1898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#009E82" />
        <stop offset="1" stop-color="#00CA9F" />
      </linearGradient>
    </defs>
  </svg>
);
